import React from 'react'
import Centered from 'shared/ui/Centered'
import Heading from 'shared/ui/Heading'
import { Hero, HeroPrimaryContent } from '../ui/Hero'
import { SlantBackground, SlantBackgroundImage } from '../ui/SlantBackground'
import GeneralContactForm from '../ui/forms/GeneralContactForm'

export default function Contact() {
  return (
    <div className="spacing-giant">
      <Hero>
        <HeroPrimaryContent>
          <div>
            <Heading className="text-color-blue">
              Hello{' '}
              <span role="img" aria-label="hand wave">
                👋
              </span>
            </Heading>
            <div className="text-large">
              Plan a workshop, ask questions about our online courses, or just ask us a general
              question.
            </div>
          </div>
        </HeroPrimaryContent>
      </Hero>

      <SlantBackground verticalOffset={-6} shallowSlant>
        <SlantBackgroundImage src="/images/react-gray-two.svg" />
      </SlantBackground>

      <Centered>
        <section className="offset-slant-background-image-left">
          <GeneralContactForm />
        </section>
      </Centered>
    </div>
  )
}
